import { EpimsBaseEntityDto } from './epim-base.dto';
export class OpllPtsHistoryDto extends EpimsBaseEntityDto{
    // id: string;
    OpllPtsNumber: string;
    Type: string;
    AutoSerialId: string;
    EntryDate: Date;
    // dateCreated: Date;
    // dateUpdated?: Date;
    // CreatedById: string;
    // ModifiedById: string;
    // SiteId: string;
    Version: number;
}